import { CREATE_PAYMENT, CREATE_PAYMENT_SUCCESS, CREATE_PAYMENT_ERROR, CREATE_PAYMENT_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreatePayment = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PAYMENT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_PAYMENT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_PAYMENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_PAYMENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreatePayment;
